export const feePricingTypeEnum = {
  PER_PERSON: 1,
  PER_RESERVATION: 2
}
